define( function() {
	return ( /\?/ );
} );



// WEBPACK FOOTER //
// ./~/jquery/src/ajax/var/rquery.js